import React from 'react';

const DevPage = React.lazy(() => import('./DevPage'));

export const AsyncDevPage: React.FC = () => (
	<React.Suspense fallback={null}>
		<DevPage />
	</React.Suspense>
);
